module.exports = __webpack_public_path__ + "img/ic_logotypewhite_1.c40e9a5a.svg";